const states = [
  'AL',
  'AK',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KA',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MO',
  'MN',
  'MT',
  'NC',
  'NE',
  'ND',
  'NH',
  'NJ',
  'NN',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TX',
  'TN',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

const parkTypes = {
  PARK: 'National Park',
  MON: 'National Monument',
  PRE: 'National Preserve',
  NMEM: 'National Memorial',
  HPARK: 'National Historic Park',
  HSITE: 'National Historic Site',
  BFIELD: 'National Battlefield',
  PFIELD: 'National Battlefield Park',
  MPARK: 'National Military Park',
  RECR: 'National Recreation Area',
  RIVER: 'National River',
  RRIVER: 'National Recreational River',
  RES: 'National Reserve',
  PRKWY: 'National Parkway',
  TRAIL: 'National Trail',
  HTRAIL: 'National Historic Trail',
  STRAIL: 'National  Scenic Trail',
  SRIVER: 'National Scenic River',
  SEA: 'National Seashore',
  LAKE: 'National Lakeshore',
};

export { states, parkTypes };
